import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';

const VARIANT_OUTLINE = 'outlined';
const VARIANT_PRIMARY = 'primary';
const VARIANT_MAIN = 'btn btn-custom btn-block';
export const VARIANTS = [VARIANT_OUTLINE, VARIANT_PRIMARY, VARIANT_MAIN];

function Button({ value, variant, type, onClick, disable }) {
    return (
        <button
            className={variant}
            onClick={onClick}
            type={type}
            disabled={disable}
        >
            {value}
        </button>
    );
}

Button.propTypes = {
    // The text to be displayed in the button
    value: PropTypes.string,

    // To select the type of button weather to be outlined or not
    // variant: PropTypes.oneOf(VARIANTS),
    variant: PropTypes.string,

    // To invoke the funtion on button press / click
    onClick: PropTypes.func,

    // To select the type of button foe e.g (submit, reset)
    type: PropTypes.string,

    disable: PropTypes.bool,
};

Button.defaultProps = {
    value: 'Button',
    variant: VARIANT_PRIMARY,
    onClick: noop,
    type: null,
    disable: false,
};

export default Button;
